// extracted by mini-css-extract-plugin
export default {"grid":"Jh68W","wrapperSidebar":"rgs6F","mainContent":"hYJwP","sidebarPositioner":"qXBrk"};